/* eslint-disable react/prop-types */
import { useState } from 'react';
// @mui
import { useNavigate } from 'react-router-dom';
import {
  Paper,
  Table,
  TableRow,
  TableBody,
  Button,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
  Pagination,
} from '@mui/material';
import { Box } from '@mui/system';
import { Edit, VisibilityOff, VisibilityOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
// icons

import { ReactComponent as EditIcon } from '../../../theme/images/editTableIcon.svg';
import { ReactComponent as ShowIcon } from '../../../theme/images/showTableIcon.svg';

// components

import Scrollbar from '../../../components/scrollbar';

// sections
import ClientReqHead from '../../../components/clientHeadTable/ClientHeadTable';

// ----------------------------------------------------------------------

const TABLE_HEAD = [];

// ----------------------------------------------------------------------

export default function ClientReqTable({ requests, handleChangePage, page, onDelete, hasEditPermission }) {
  const [rowsPerPage] = useState(1);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';
  const baseTableHead = [
    { id: 'NAME_EN', label: t('General.name'), alignRight: isRtl && true },
    { id: 'ownerId', label: t('ManageProject.ownerName'), alignRight: isRtl && true },
    { id: 'creation_date', label: t('General.creationDate'), alignRight: isRtl && true },
    { id: 'last_update_date', label: t('General.lastUpdateDate'), alignRight: isRtl && true },

    { id: 'status', label: t('General.Status'), alignRight: isRtl && true },
    { id: 'action', label: t('General.Action'), alignRight: isRtl && true },
  ];

  const TABLE_HEAD = [...baseTableHead];
  // if (hasEditPermission) {
  //   TABLE_HEAD.push({ id: 'action', label: 'Action', alignRight: false });
  // }
  return (
    <>
      <Scrollbar>
        <TableContainer component={Paper} sx={{ minWidth: 800 }}>
          <Table sx={{ direction: isRtl ? 'rtl' : 'ltr' }}>
            <ClientReqHead headLabel={TABLE_HEAD} />
            <TableBody>
              {requests?.content?.map((row) => {
                const { id, nameEn, nameAr, creationDate, owner, planStatus, lastUpdateDate } = row;
                const displayDate = creationDate || new Date().toLocaleDateString();

                return (
                  <TableRow hover key={id} tabIndex={-1}>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }} component="th" scope="row">
                      <Typography
                        sx={{ color: 'text.secondary', fontWeight: '400', fontSize: '12px', lineHeight: '20px' }}
                        variant="subtitle2"
                        noWrap
                      >
                        {isRtl ? nameAr : nameEn}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }} component="th" scope="row">
                      <Typography
                        sx={{ color: 'text.secondary', fontWeight: '400', fontSize: '12px', lineHeight: '20px' }}
                        variant="subtitle2"
                        noWrap
                      >
                        {isRtl ? owner.nameAr : owner.nameEn || ''}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }} component="th" scope="row">
                      <Typography
                        sx={{ color: 'text.secondary', fontWeight: '400', fontSize: '12px', lineHeight: '20px' }}
                        variant="subtitle2"
                        noWrap
                      >
                        {displayDate || ''}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }} component="th" scope="row">
                      <Typography
                        sx={{ color: 'text.secondary', fontWeight: '400', fontSize: '12px', lineHeight: '20px' }}
                        variant="subtitle2"
                        noWrap
                      >
                        {lastUpdateDate || ''}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }} component="th" scope="row">
                      {planStatus === 'TRUE' ? (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '4px 16px',
                            backgroundColor: '#E7F7EF',
                            borderRadius: '8px',
                            width: '88px',
                          }}
                        >
                          <Typography
                            sx={{ color: '#0CAF60', fontWeight: '700', fontSize: '10px', lineHeight: '16px' }}
                            variant="subtitle2"
                            textAlign={'center'}
                            noWrap
                          >
                            {t('General.Active')}
                          </Typography>
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '4px 16px',
                            backgroundColor: '#FFEDEC',
                            borderRadius: '8px',
                            width: '88px',
                          }}
                        >
                          <Typography
                            sx={{ color: '#E03137', fontWeight: '700', fontSize: '10px', lineHeight: '16px' }}
                            variant="subtitle2"
                            textAlign={'center'}
                            noWrap
                          >
                            {t('General.InActive')}
                          </Typography>
                        </Box>
                      )}
                    </TableCell>
                    {hasEditPermission && (
                      <TableCell align="left">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                          <Button
                            onClick={() =>
                              navigate(`/dashboard/plans/view/${id}`, {
                                state: { editData: row },
                              })
                            }
                          >
                            <ShowIcon />
                          </Button>
                          <Button
                            onClick={() =>
                              navigate(id ? `/dashboard/plans/edit/${id}` : '/dashboard/plan/add', {
                                state: { editData: row },
                              })
                            }
                          >
                            <EditIcon />
                          </Button>
                        </Box>
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Scrollbar>
      {requests?.totalElements === 0 && (
        <Box textAlign="center">
          <h5>No data found</h5>
        </Box>
      )}
      {requests?.totalPages > 0 && (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px',
            marginTop: '5rem',
          }}
        >
          <Pagination count={requests.totalPages} page={page + 1} onChange={handleChangePage} color="primary" />
          <Box sx={{ display: 'block' }}>
            {t('General.showing')} {page * rowsPerPage + 1} {t('General.of')}{' '}
            {Math.min((page + 1) * rowsPerPage, requests.totalElements)} {t('General.to')} {requests.totalElements}{' '}
            {t('General.entries')}
          </Box>
        </Box>
      )}
    </>
  );
}
